"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CopyLanguageHelpers = exports.CopyLanguage = void 0;
var CopyLanguage;
(function (CopyLanguage) {
    CopyLanguage["AM"] = "AM";
    CopyLanguage["AR"] = "AR";
    CopyLanguage["EU"] = "EU";
    CopyLanguage["BN"] = "BN";
    CopyLanguage["EN"] = "EN";
    CopyLanguage["PT"] = "PT";
    CopyLanguage["BG"] = "BG";
    CopyLanguage["CA"] = "CA";
    CopyLanguage["CHR"] = "CHR";
    CopyLanguage["HR"] = "HR";
    CopyLanguage["CS"] = "CS";
    CopyLanguage["DA"] = "DA";
    CopyLanguage["NL"] = "NL";
    CopyLanguage["ET"] = "ET";
    CopyLanguage["FIL"] = "FIL";
    CopyLanguage["FI"] = "FI";
    CopyLanguage["FR"] = "FR";
    CopyLanguage["DE"] = "DE";
    CopyLanguage["EL"] = "EL";
    CopyLanguage["GU"] = "GU";
    CopyLanguage["IW"] = "IW";
    CopyLanguage["HI"] = "HI";
    CopyLanguage["HU"] = "HU";
    CopyLanguage["IS"] = "IS";
    CopyLanguage["ID"] = "ID";
    CopyLanguage["IT"] = "IT";
    CopyLanguage["JA"] = "JA";
    CopyLanguage["KN"] = "KN";
    CopyLanguage["KO"] = "KO";
    CopyLanguage["LV"] = "LV";
    CopyLanguage["LT"] = "LT";
    CopyLanguage["MS"] = "MS";
    CopyLanguage["ML"] = "ML";
    CopyLanguage["MR"] = "MR";
    CopyLanguage["NO"] = "NO";
    CopyLanguage["PL"] = "PL";
    CopyLanguage["RO"] = "RO";
    CopyLanguage["RU"] = "RU";
    CopyLanguage["SR"] = "SR";
    CopyLanguage["ZH"] = "ZH";
    CopyLanguage["SK"] = "SK";
    CopyLanguage["SL"] = "SL";
    CopyLanguage["ES"] = "ES";
    CopyLanguage["SW"] = "SW";
    CopyLanguage["SV"] = "SV";
    CopyLanguage["TA"] = "TA";
    CopyLanguage["TE"] = "TE";
    CopyLanguage["TH"] = "TH";
    CopyLanguage["TR"] = "TR";
    CopyLanguage["UR"] = "UR";
    CopyLanguage["UK"] = "UK";
    CopyLanguage["VI"] = "VI";
    CopyLanguage["CY"] = "CY";
})(CopyLanguage = exports.CopyLanguage || (exports.CopyLanguage = {}));
var CopyLanguageHelpers = (function () {
    function CopyLanguageHelpers() {
    }
    CopyLanguageHelpers.isValid = function (value) {
        return CopyLanguageHelpers.all.indexOf(value) >= 0;
    };
    CopyLanguageHelpers.all = [
        CopyLanguage.AM,
        CopyLanguage.AR,
        CopyLanguage.EU,
        CopyLanguage.BN,
        CopyLanguage.EN,
        CopyLanguage.PT,
        CopyLanguage.BG,
        CopyLanguage.CA,
        CopyLanguage.CHR,
        CopyLanguage.HR,
        CopyLanguage.CS,
        CopyLanguage.DA,
        CopyLanguage.NL,
        CopyLanguage.ET,
        CopyLanguage.FIL,
        CopyLanguage.FI,
        CopyLanguage.FR,
        CopyLanguage.DE,
        CopyLanguage.EL,
        CopyLanguage.GU,
        CopyLanguage.IW,
        CopyLanguage.HI,
        CopyLanguage.HU,
        CopyLanguage.IS,
        CopyLanguage.ID,
        CopyLanguage.IT,
        CopyLanguage.JA,
        CopyLanguage.KN,
        CopyLanguage.KO,
        CopyLanguage.LV,
        CopyLanguage.LT,
        CopyLanguage.MS,
        CopyLanguage.ML,
        CopyLanguage.MR,
        CopyLanguage.NO,
        CopyLanguage.PL,
        CopyLanguage.RO,
        CopyLanguage.RU,
        CopyLanguage.SR,
        CopyLanguage.ZH,
        CopyLanguage.SK,
        CopyLanguage.SL,
        CopyLanguage.ES,
        CopyLanguage.SW,
        CopyLanguage.SV,
        CopyLanguage.TA,
        CopyLanguage.TE,
        CopyLanguage.TH,
        CopyLanguage.TR,
        CopyLanguage.UR,
        CopyLanguage.UK,
        CopyLanguage.VI,
        CopyLanguage.CY
    ];
    return CopyLanguageHelpers;
}());
exports.CopyLanguageHelpers = CopyLanguageHelpers;
var irt_1 = require("@playq/irt");
irt_1.Introspector.register('net.playq.octopus2.creatives.CopyLanguage', {
    full: 'net.playq.octopus2.creatives.CopyLanguage',
    short: 'CopyLanguage',
    package: 'net.playq.octopus2.creatives',
    type: irt_1.IntrospectorTypes.Enum,
    options: CopyLanguageHelpers.all
});
//# sourceMappingURL=CopyLanguage.js.map